export default {
  title: 'Nebula buds AI Chiamata', // "Nebula buds AI通话" 翻译为意大利语
  userID: 'ID utente : ', // "用户ID : "
  hurryUp: 'In attesa della chiamata dall\'altra parte', // "等待对方呼叫"
  waitingCall: 'In attesa della chiamata dall\'altra parte su questa pagina, non chiudere la pagina prematuramente.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Interruttore sottotitoli', // "字幕开关"
  initWait: 'In attesa dell\'inizializzazione', // "等待初始化"
  initSuccess: 'Inizializzazione completata, in attesa della chiamata dall\'altra parte. Non chiudere la pagina!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Chiamata connessa', // "电话接通"
  callEnd: 'Chiamata terminata', // "通话结束"
  careful: 'Attenzione : ', // "注意 : "
  wait: 'Componente di chiamata pronto, in attesa della chiamata dall\'altra parte', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabo', // "阿拉伯语"
    da: 'Danese', // "丹麦语"
    de: 'Tedesco', // "德语"
    en: 'Inglese', // "英语"
    es: 'Spagnolo', // "西班牙语"
    fil: 'Filippino', // "菲律宾语"
    fr: 'Francese', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesiano', // "印度尼西亚语"
    it: 'Italiano', // "意大利语"
    ja: 'Giapponese', // "日文"
    ko: 'Coreano', // "韩语"
    ms: 'Malese', // "马来语"
    no: 'Norvegese', // "挪威语"
    pt: 'Portoghese', // "葡萄牙语"
    ru: 'Russo', // "俄语"
    sv: 'Svedese', // "瑞典语"
    th: 'Thailandese', // "泰语"
    tr: 'Turco', // "土耳其语"
    vi: 'Vietnamita', // "越南语"
    zh: 'Cinese' // "中文"
  }
}
